/**
 * File generated by js-routes 2.2.7
 * Based on Rails 7.1.4.2 routes of Shoretime::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * (/:locale)/tours/:id/accept_arrangements(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_arrangements_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept_arrangements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/accept_bid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_bid_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_applications/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_onboarding_operator_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/exports/active_operator_application_signatories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_operator_application_signatories_onboarding_exports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"active_operator_application_signatories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/add_contract_period(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_contract_period_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_contract_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/add_departure(.:format)
 * @param {any} season_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_departure_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"add_departure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/add_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_departures_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"add_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/agent_health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agent_health_check_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"agent_health_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/allocate_inventory(.:format)
 * @param {any} season_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allocate_inventory_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"allocate_inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/alternative_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alternative_tours_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"alternative_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/append_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const append_departures_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"append_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles/apply_to_cruise_company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_to_cruise_company_onboarding_operator_profiles_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[6,"apply_to_cruise_company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/apply_to_tours_diff(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_to_tours_diff_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_to_tours_diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/apply_to_tours(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_to_tours_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_to_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/apply_to_tours_run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_to_tours_run_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_to_tours_run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/approve_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_departures_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"approve_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/approve_or_reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_or_reject_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_or_reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/products/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_onboarding_tour_library_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/assign_bidding_regions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_bidding_regions_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_bidding_regions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/prospective_award_sets/:id/assign_operator(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_operator_onboarding_prospective_award_set_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"prospective_award_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/assign_roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_roles_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticator_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/:authenticator_id/disable_scim(.:format)
 * @param {any} authenticator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticator_disable_scim_path = /*#__PURE__*/ __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"disable_scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/:authenticator_id/enable(.:format)
 * @param {any} authenticator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticator_enable_path = /*#__PURE__*/ __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/:authenticator_id/enable_scim(.:format)
 * @param {any} authenticator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticator_enable_scim_path = /*#__PURE__*/ __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"enable_scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/:authenticator_id/reset_scim(.:format)
 * @param {any} authenticator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticator_reset_scim_path = /*#__PURE__*/ __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"reset_scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticators_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/auto_instrument_expection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_instrument_expection_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"auto_instrument_expection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/prospective_award_sets/:id/award_bids(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_bids_onboarding_prospective_award_set_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"prospective_award_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"award_bids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/basic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basic_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"basic"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tickets/batch_print(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_print_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"batch_print"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/tour_change_letters/batch_print(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_print_tour_change_letters_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tour_change_letters"],[2,[7,"/"],[2,[6,"batch_print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/bid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bid_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/booking_guests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const booking_guests_guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"booking_guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/bookings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookings_guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/bulk_cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_cancel_tour_bookings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[6,"bulk_cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/bulk_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_export_onboarding_tour_library_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"bulk_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_applications/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_onboarding_operator_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/cancel_port(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_port_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"cancel_port"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_private_car_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/caught_expection_string(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caught_expection_string_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"caught_expection_string"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/caught_expection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caught_expection_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"caught_expection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_chooser/choose/:company_id(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const choose_company_chooser_path = /*#__PURE__*/ __jsr.r({"locale":{},"company_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_chooser"],[2,[7,"/"],[2,[6,"choose"],[2,[7,"/"],[2,[3,"company_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/crew_chooser/choose/:crew_id(.:format)
 * @param {any} crew_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const choose_crew_chooser_path = /*#__PURE__*/ __jsr.r({"locale":{},"crew_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"crew_chooser"],[2,[7,"/"],[2,[6,"choose"],[2,[7,"/"],[2,[3,"crew_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/voyage_chooser/choose/:voyage_id(.:format)
 * @param {any} voyage_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const choose_voyage_chooser_path = /*#__PURE__*/ __jsr.r({"locale":{},"voyage_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyage_chooser"],[2,[7,"/"],[2,[6,"choose"],[2,[7,"/"],[2,[3,"voyage_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/cleared_to_leave(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleared_to_leave_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cleared_to_leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_sales/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_daily_sale_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/close_days(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_days_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"close_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/comment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_chooser(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_chooser_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_chooser"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company/:company_uri/login(.:format)
 * @param {any} company_uri
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_login_path = /*#__PURE__*/ __jsr.r({"locale":{},"company_uri":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[3,"company_uri"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/complaint_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complaint_categories_guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"complaint_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const components_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/confirm_email_addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_email_address_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"confirm_email_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/confirm_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_email_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"confirm_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/settlement/confirm_guests(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_guests_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"confirm_guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_private_car_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/confirmable_bookings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmable_bookings_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"confirmable_bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversation_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/conversations/:id/messages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversation_messages_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/crew_chooser(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crew_chooser_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"crew_chooser"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_manifest_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_manifest"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_sale_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_sales_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_settlement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_settlement"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/background_jobs/exports/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_background_jobs_export_download_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/background_jobs/exports/:id/report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_background_jobs_export_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/background_jobs/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_background_jobs_exports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/background_jobs/imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_background_jobs_imports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_export_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/export_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_export_items_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"export_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/analytics_feed/branded_tour_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_analytics_feed_branded_tour_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"branded_tour_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/analytics_feed/inventory_departure_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_analytics_feed_inventory_departure_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"inventory_departure_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/analytics_feed/operator_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_analytics_feed_operator_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"operator_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/analytics_feed/operator_insurance_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_analytics_feed_operator_insurance_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"operator_insurance_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/analytics_feed/sales_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_analytics_feed_sales_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"sales_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/analytics_feed/voyage_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_analytics_feed_voyage_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"voyage_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/internal_tour_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_internal_tour_status_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"internal_tour_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/allocation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_inventory_allocation_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"allocation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/departure_allocations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_inventory_departure_allocations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_allocations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/departure_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_inventory_departure_changes_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_inventory_sales_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/tracker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_inventory_tracker_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"tracker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/nclh/branded_tour_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_nclh_branded_tour_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"branded_tour_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/nclh/inventory_departure_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_nclh_inventory_departure_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"inventory_departure_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/nclh/operator_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_nclh_operator_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"operator_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/nclh/operator_insurance_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_nclh_operator_insurance_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"operator_insurance_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/nclh/sales_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_nclh_sales_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"sales_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/nclh/voyage_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_nclh_voyage_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"voyage_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/otalio_export_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_otalio_export_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_export_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/otalio_product_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_otalio_product_export_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_product_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/tour_cost(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_exports_tour_cost_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"tour_cost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_import_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/import_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_import_items_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"import_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_imports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/:import_type/sample(.:format)
 * @param {any} import_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_imports_import_sample_path = /*#__PURE__*/ __jsr.r({"locale":{},"import_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_type"],[2,[7,"/"],[2,[6,"sample"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/ims_voyage_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_imports_ims_voyage_import_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"ims_voyage_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/otalio_sales_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_imports_otalio_sales_import_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"otalio_sales_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_exchange_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/departed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const departed_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"departed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/disable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_authenticators_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dispatch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispatch_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/dispatch_started(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispatch_started_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dispatch_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/settlement/dispute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispute_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"dispute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/:id/download_bid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_bid_onboarding_tour_library_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/authenticator/download_certificate/:certificate_name/:token(.:format)
 * @param {any} certificate_name
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_certificate_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"certificate_name":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"authenticator"],[2,[7,"/"],[2,[6,"download_certificate"],[2,[7,"/"],[2,[3,"certificate_name"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_onboarding_tour_library_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/components/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_component_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_sales/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_daily_sale_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_exchange_export_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/edit_departure_time(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_departure_time_tour_bookings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[6,"edit_departure_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guest_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_booked_tour_account/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guests_booked_tour_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_feedback/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guests_feedback_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_room_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guests_room_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tours/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guests_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tour_description/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guests_tour_description_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passengers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passenger_prices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_passenger_price_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/ports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_port_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_private_car_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reset_password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reset_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reset_password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/rooms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_room_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/room_occupancies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_room_occupancy_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/general_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_general_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/tour_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_tour_type_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/timeslots/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_timeslot_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_booking_passengers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tour_booking_passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:tour_id/guest_complaints/:id/edit(.:format)
 * @param {any} tour_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tour_guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tour_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_transport_rental_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_classes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_transport_rentals_vehicle_class_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_pools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_transport_rentals_vehicle_pool_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tickets/:id/embed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_ticket_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/export_bids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_bids_onboarding_bidding_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"export_bids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/departure_allocations/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_data_exchange_exports_inventory_departure_allocations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_allocations"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/inventory/departure_changes/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_data_exchange_exports_inventory_departure_changes_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_changes"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/tour_cost/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_data_exchange_exports_tour_cost_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"tour_cost"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_onboarding_tour_library_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /feature_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/field_import_diff(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_import_diff_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"field_import_diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /file_holders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_holder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_holders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/insurance_dashboard/filter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_insurance_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"insurance_dashboard"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/filter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/filter(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/settlement/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guest_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_booked_tour_account/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_booked_tour_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_booked_tour_account/:guests_booked_tour_account_id/guests_booked_tour_account(.:format)
 * @param {any} guests_booked_tour_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_booked_tour_account_guests_booked_tour_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"guests_booked_tour_account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[3,"guests_booked_tour_account_id"],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_booked_tour_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_booked_tour_account_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_feedback/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_feedback_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_feedback/:guests_feedback_id/guests_feedback(.:format)
 * @param {any} guests_feedback_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_feedback_guests_feedback_path = /*#__PURE__*/ __jsr.r({"locale":{},"guests_feedback_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[3,"guests_feedback_id"],[2,[7,"/"],[2,[6,"guests_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_feedback_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_room_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_room_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_room_accounts/:guests_room_account_id/guests_room_accounts(.:format)
 * @param {any} guests_room_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_room_account_guests_room_accounts_path = /*#__PURE__*/ __jsr.r({"locale":{},"guests_room_account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[3,"guests_room_account_id"],[2,[7,"/"],[2,[6,"guests_room_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_room_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_room_accounts_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tours/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tour_description/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_tour_description_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tour_description/:guests_tour_description_id/guests_tour_description(.:format)
 * @param {any} guests_tour_description_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_tour_description_guests_tour_description_path = /*#__PURE__*/ __jsr.r({"locale":{},"guests_tour_description_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[3,"guests_tour_description_id"],[2,[7,"/"],[2,[6,"guests_tour_description"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tour_description(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_tour_description_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tours/:guests_tour_id/guests_tours(.:format)
 * @param {any} guests_tour_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_tour_guests_tours_path = /*#__PURE__*/ __jsr.r({"locale":{},"guests_tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[3,"guests_tour_id"],[2,[7,"/"],[2,[6,"guests_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guests_tours_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/identity_provider(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identity_provider_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"identity_provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/guest_complaints/input(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_reports_guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/revenue/input(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_reports_revenue_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/revenue_sources/input(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_reports_revenue_sources_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue_sources"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/voyage_revenues/input(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_reports_voyage_revenues_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voyage_revenues"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/insurance_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insurance_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"insurance_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/inventory/inventory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inventory_settings_inventory_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles/invite_operator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_operator_onboarding_operator_profiles_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[6,"invite_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/lock_days(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lock_days_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"lock_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/manual_booking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_settlement/mark_as_paid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_paid_daily_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_settlement"],[2,[7,"/"],[2,[6,"mark_as_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/conversations/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_conversation_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]]);

/**
 * Generates rails route to
 * /mc/jobs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_mass_update_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/:id/discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_discard_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/:id/force_discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_force_discard_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/:id/reschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_reschedule_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_retry_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/metrics/primary_nav(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_metrics_primary_nav_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"primary_nav"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/jobs/metrics/job_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_metrics_job_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"job_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_batches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_batch_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/cron_entries/:cron_key/enqueue(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_enqueue_cron_entry_path = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enqueue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/cron_entries/:cron_key/enable(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_enable_cron_entry_path = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/cron_entries/:cron_key/disable(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_disable_cron_entry_path = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/cron_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_cron_entries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/cron_entries/:cron_key(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_cron_entry_path = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_processes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_performance_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"performance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/frontend/modules/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_frontend_module_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mc/jobs/frontend/static/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mc_good_job_frontend_static_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"static"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/components/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_component_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_sales/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_daily_sale_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_export_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/otalio_export_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_exports_otalio_export_setting_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_export_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/otalio_product_export/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_exports_otalio_product_export_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_product_export"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_import_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/ims_voyage_import/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_imports_ims_voyage_import_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"ims_voyage_import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/otalio_sales_import/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_imports_otalio_sales_import_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"otalio_sales_import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/integrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_exchange_integration_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guest_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_booked_tour_account/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guests_booked_tour_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_feedback/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guests_feedback_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_room_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guests_room_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tours/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guests_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guests_tour_description/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guests_tour_description_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/off_schedule_inventories/remove_departures/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_off_schedule_inventories_remove_departure_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"off_schedule_inventories"],[2,[7,"/"],[2,[6,"remove_departures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/accept_contract_period_details_rejection/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_accept_contract_period_details_rejection_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_contract_period_details_rejection"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/accept_tender_bid/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_accept_tender_bid_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/appoint_operator/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_appoint_operator_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"appoint_operator"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/close_current_tender_bidding_round/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_close_current_tender_bidding_round_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"close_current_tender_bidding_round"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/confirm_contract_period_details/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_confirm_contract_period_detail_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"confirm_contract_period_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/contract_tours/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_contract_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"contract_tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/cruise_line_suggest_contract_period_details_confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_cruise_line_suggest_contract_period_details_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"cruise_line_suggest_contract_period_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/deny_appointment/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_deny_appointment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"deny_appointment"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/enable_product_component_bidding/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_enable_product_component_bidding_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"enable_product_component_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/invite_tender_bidders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_invite_tender_bidder_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_tender_bidders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/invite_to_bid/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_invite_to_bid_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_to_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/lock_product_component_editing/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_lock_product_component_editing_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"lock_product_component_editing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/open_current_tender_bidding_round/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_open_current_tender_bidding_round_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"open_current_tender_bidding_round"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/pend_tender_bid/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_pend_tender_bid_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"pend_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/reject_contract_period_details/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_reject_contract_period_detail_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/reject_contract_period_details_rejection/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_reject_contract_period_details_rejection_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details_rejection"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/reject_tender_bid/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_reject_tender_bid_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/request_bid_resubmission/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_request_bid_resubmission_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_bid_resubmission"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/request_contract_period_details_confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_request_contract_period_details_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_contract_period_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/request_tour_details_confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_request_tour_details_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_tour_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/revoke_bid_invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_revoke_bid_invitation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_bid_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/revoke_tender_bid_invite/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_revoke_tender_bid_invite_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_tender_bid_invite"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/submit_cost_changes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_submit_cost_change_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_cost_changes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/submit_tender_bid/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_submit_tender_bid_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/suggest_contract_period_details_confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_suggest_contract_period_details_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"suggest_contract_period_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/unlock_product_component_editing/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_unlock_product_component_editing_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"unlock_product_component_editing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_bidding_deadline/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_update_bidding_deadline_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_bidding_deadline"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_field_permissions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_update_field_permission_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_field_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_individual_field_permissions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_update_individual_field_permission_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_individual_field_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_participation_counts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_update_participation_count_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_participation_counts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_pricing/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_update_pricing_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_pricing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_ratesheet_type_lock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_bidding_update_ratesheet_type_lock_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_ratesheet_type_lock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/accept_product_appointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_contracting_accept_product_appointment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"accept_product_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/cancel_product_appointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_contracting_cancel_product_appointment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cancel_product_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/finalize_product_appointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_contracting_finalize_product_appointment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"finalize_product_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/operator_percentage_assignment/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_contracting_operator_percentage_assignment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"operator_percentage_assignment"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/reopen_products_for_bidding/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_contracting_reopen_products_for_bidding_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"reopen_products_for_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/revert_contracting/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_contracting_revert_contracting_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"revert_contracting"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/edit_main_details/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_edit_main_detail_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_main_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_registrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_operator_registration_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_registrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_operators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_add_operator_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_operators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_ports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_add_port_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_ports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_season/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_add_season_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/archive_season/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_archive_season_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"archive_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/duplicate_season_for_bidding/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_duplicate_season_for_bidding_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_for_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/duplicate_season_with_appointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_duplicate_season_with_appointment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_with_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/remove_operators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_remove_operator_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_operators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/remove_ports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_remove_port_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_ports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/renew_tour_appointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_renew_tour_appointment_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tour_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/renew_tours_for_bidding/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_renew_tours_for_bidding_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tours_for_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/unarchive_season/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_unarchive_season_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"unarchive_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/update_season/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_seasons_update_season_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"update_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/cruise_lines/add_tour/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_library_cruise_lines_add_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/cruise_lines/add_tour_to_season/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_library_cruise_lines_add_tour_to_season_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour_to_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/cruise_lines/update_status_tag/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_library_cruise_lines_update_status_tag_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"update_status_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/operators/add_tour_idea/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_library_operators_add_tour_idea_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"operators"],[2,[7,"/"],[2,[6,"add_tour_idea"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_season/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_marketplace_add_tour_ideas_to_season_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_tour_library/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_marketplace_add_tour_ideas_to_tour_library_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_tour_library"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace/product_proposal_management/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_tour_marketplace_product_proposal_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"product_proposal_management"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passengers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passenger_prices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_passenger_price_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /platforms/super_admins/iams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_platforms_super_admins_iam_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"platforms"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"iams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/ports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_port_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_private_car_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reset_password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reset_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reset_password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/rooms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_room_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/room_occupancies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_room_occupancy_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/general_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_general_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags/add_internal_tag/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_internal_tags_add_internal_tag_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"add_internal_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags/remove_internal_tag/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_internal_tags_remove_internal_tag_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"remove_internal_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags/update_internal_tag/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_internal_tags_update_internal_tag_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"update_internal_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/tour_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_tour_type_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/timeslots/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_timeslot_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_booking_passengers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tour_booking_passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:tour_id/guest_complaints/new(.:format)
 * @param {any} tour_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tour_guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tour_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_transport_rental_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_classes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_transport_rentals_vehicle_class_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_pools/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_transport_rentals_vehicle_pool_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/off_schedule_inventories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const off_schedule_inventories_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"off_schedule_inventories"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/off_schedule_inventories/remove_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const off_schedule_inventories_remove_departures_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"off_schedule_inventories"],[2,[7,"/"],[2,[6,"remove_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/authenticators/offload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offload_authenticators_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[6,"offload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_admin_status_dashboard/:operator_id/archive(.:format)
 * @param {any} operator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_archive_operator_admin_status_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_admin_status_dashboard"],[2,[7,"/"],[2,[3,"operator_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/accept_contract_period_details_rejection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_accept_contract_period_details_rejection_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_contract_period_details_rejection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/accept_tender_bid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_accept_tender_bid_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/appoint_operator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_appoint_operator_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"appoint_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/close_current_tender_bidding_round(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_close_current_tender_bidding_round_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"close_current_tender_bidding_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/confirm_contract_period_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_confirm_contract_period_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"confirm_contract_period_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/contract_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_contract_tours_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"contract_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/cruise_line_suggest_contract_period_details_confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_cruise_line_suggest_contract_period_details_confirmation_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"cruise_line_suggest_contract_period_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/deny_appointment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_deny_appointment_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"deny_appointment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/enable_product_component_bidding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_enable_product_component_bidding_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"enable_product_component_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/invite_tender_bidders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_invite_tender_bidders_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_tender_bidders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/invite_to_bid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_invite_to_bid_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_to_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/lock_product_component_editing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_lock_product_component_editing_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"lock_product_component_editing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/open_current_tender_bidding_round(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_open_current_tender_bidding_round_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"open_current_tender_bidding_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding_overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_overview_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding_overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/pend_tender_bid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_pend_tender_bid_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"pend_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/reject_contract_period_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_reject_contract_period_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/reject_contract_period_details_rejection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_reject_contract_period_details_rejection_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details_rejection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/reject_tender_bid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_reject_tender_bid_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/request_bid_resubmission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_request_bid_resubmission_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_bid_resubmission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/request_contract_period_details_confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_request_contract_period_details_confirmation_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_contract_period_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/request_tour_details_confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_request_tour_details_confirmation_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_tour_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/revoke_bid_invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_revoke_bid_invitations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_bid_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/revoke_tender_bid_invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_revoke_tender_bid_invite_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_tender_bid_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/submit_cost_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_submit_cost_changes_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_cost_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/submit_tender_bid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_submit_tender_bid_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/suggest_contract_period_details_confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_suggest_contract_period_details_confirmation_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"suggest_contract_period_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/unlock_product_component_editing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_unlock_product_component_editing_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"unlock_product_component_editing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_bidding_deadline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_bidding_deadline_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_bidding_deadline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_field_permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_field_permissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_field_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_individual_field_permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_individual_field_permissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_individual_field_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_participation_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_participation_counts_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_participation_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_pricing_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_pricing_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_ratesheet_type_lock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_ratesheet_type_lock_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_ratesheet_type_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/bidding/update_ratesheet_type_lock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_bidding_update_ratesheet_type_lock_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_ratesheet_type_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/accept_product_appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_accept_product_appointments_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"accept_product_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/cancel_product_appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_cancel_product_appointments_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cancel_product_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/cruise_line(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_cruise_line_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cruise_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/finalize_product_appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_finalize_product_appointments_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"finalize_product_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/operator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_operator_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/operator_percentage_assignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_operator_percentage_assignment_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"operator_percentage_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/reopen_products_for_bidding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_reopen_products_for_bidding_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"reopen_products_for_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/revert_contracting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_contracting_revert_contracting_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"revert_contracting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_documents_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/edit_main_details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_edit_main_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_main_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/mismatched_sales_inventories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_mismatched_sales_inventories_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"mismatched_sales_inventories"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_admin_status_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_admin_status_dashboard_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_admin_status_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_profile_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles/:operator_profile_id/applications/:id/approve(.:format)
 * @param {any} operator_profile_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_profile_approve_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles/:operator_profile_id/applications/:id/reject(.:format)
 * @param {any} operator_profile_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_profile_reject_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles/:operator_profile_id/update_settings(.:format)
 * @param {any} operator_profile_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_profile_update_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_profiles_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_profiles_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_profiles_dashboard_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_registrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_operator_registrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/audit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_product_audit_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/cost_analysis(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_product_cost_analysis_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cost_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_products_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/:season_id/cost_analysis(.:format)
 * @param {any} season_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_season_cost_analysis_path = /*#__PURE__*/ __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"cost_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_operators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_add_operators_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_ports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_add_ports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_add_season_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/add_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_add_tours_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/archive_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_archive_season_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"archive_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/duplicate_season_for_bidding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_duplicate_season_for_bidding_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_for_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/duplicate_season_with_appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_duplicate_season_with_appointments_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_with_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/operators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_operators_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/ports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_ports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/remove_operators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_remove_operators_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/remove_ports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_remove_ports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/renew_tour_appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_renew_tour_appointments_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tour_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/renew_tours_for_bidding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_renew_tours_for_bidding_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tours_for_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_tours_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/unarchive_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_unarchive_season_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"unarchive_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/update_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_seasons_update_season_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"update_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/cruise_lines/add_tour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_library_cruise_lines_add_tour_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/cruise_lines/add_tour_to_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_library_cruise_lines_add_tour_to_season_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour_to_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/cruise_lines/update_status_tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_library_cruise_lines_update_status_tag_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"update_status_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_library_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/operators/add_tour_idea(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_library_operators_add_tour_idea_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"operators"],[2,[7,"/"],[2,[6,"add_tour_idea"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_marketplace_add_tour_ideas_to_season_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_tour_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_marketplace_add_tour_ideas_to_tour_library_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_tour_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_marketplace_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_marketplace/product_proposal_management(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_tour_marketplace_product_proposal_management_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"product_proposal_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_admin_status_dashboard/:operator_id/unarchive(.:format)
 * @param {any} operator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_unarchive_operator_admin_status_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_admin_status_dashboard"],[2,[7,"/"],[2,[3,"operator_id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_sales/:id/open(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_daily_sale_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/open_days(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_days_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"open_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/open(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/operator_check_in(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_check_in_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_check_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/operator_profiles/:operator_profile_id/insurances/:insurance_id/update_certificate(.:format)
 * @param {any} operator_profile_id
 * @param {any} insurance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_profile_insurance_update_certificate_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"insurance_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[2,[7,"/"],[2,[3,"insurance_id"],[2,[7,"/"],[2,[6,"update_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/operator_profiles/:operator_profile_id/insurances/:insurance_id/update_selected_items(.:format)
 * @param {any} operator_profile_id
 * @param {any} insurance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_profile_insurance_update_selected_items_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"insurance_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[2,[7,"/"],[2,[3,"insurance_id"],[2,[7,"/"],[2,[6,"update_selected_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/operator_profiles/:operator_profile_id/insurances/:insurance_id/upload_certificate(.:format)
 * @param {any} operator_profile_id
 * @param {any} insurance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_profile_insurance_upload_certificate_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"insurance_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[2,[7,"/"],[2,[3,"insurance_id"],[2,[7,"/"],[2,[6,"upload_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/operator_profiles/:operator_profile_id/insurances(.:format)
 * @param {any} operator_profile_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_profile_insurances_path = /*#__PURE__*/ __jsr.r({"locale":{},"operator_profile_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_applications/:id/operator_questionnaire(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_questionnaire_onboarding_operator_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_questionnaire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/operator_registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operator_registration_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_registration"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dispatch/operators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operators_dispatch_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[6,"operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passengers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passenger_prices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passenger_price_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passenger_prices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passenger_prices_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passengers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passengers_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/pend_bid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pend_bid_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pend_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /platforms/super_admins/iams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const platforms_super_admins_iams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"platforms"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"iams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/ports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const port_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/manual_booking/port(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const port_manual_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[2,[7,"/"],[2,[6,"port"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/ports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/exports/ports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ports_onboarding_exports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/settlement/price_breakdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_breakdown_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"price_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_car_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/:private_car_booking_id/tickets(.:format)
 * @param {any} private_car_booking_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_car_booking_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"private_car_booking_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"private_car_booking_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dispatch/private_villas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_villas_dispatch_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[6,"private_villas"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/exports/:id/process_export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_export_data_exchange_export_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data_exchange/imports/:id/process_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_import_data_exchange_import_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/exports/product_comparison(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_comparison_onboarding_exports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"product_comparison"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/proposals/:proposal_id/accept(.:format)
 * @param {any} id
 * @param {any} proposal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposal_accept_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"proposal_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"proposal_id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/proposals/:proposal_id/reject(.:format)
 * @param {any} id
 * @param {any} proposal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposal_reject_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"proposal_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"proposal_id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/propose(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const propose_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"propose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/react_with_error_boundary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const react_with_error_boundary_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"react_with_error_boundary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/react_without_error_boundary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const react_without_error_boundary_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"react_without_error_boundary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/rebook(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rebook_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/reject_bid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_bid_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/remove_bid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_bid_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/remove_departure(.:format)
 * @param {any} season_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_departure_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"remove_departure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/remove_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_departures_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"remove_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/replace_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replace_departures_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"replace_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/conversations/:id/reply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_conversation_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/daily_spend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_daily_spend_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"daily_spend"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/guest_complaints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guest_complaints"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_revenue_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/revenue_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_revenue_sources_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/voyage_performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_voyage_performance_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voyage_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/voyage_revenues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_voyage_revenues_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voyage_revenues"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/request_password_reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_password_reset_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/resend_email_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_email_confirmation_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_email_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/guest_complaints/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/operator_applications/:id/retract(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retract_onboarding_operator_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/return_to_setup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const return_to_setup_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"return_to_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dispatch/reverse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_dispatch_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[6,"reverse"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/rooms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const room_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/passengers/:id/room_account(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const room_account_passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"room_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/room_occupancies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const room_occupancies_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/room_occupancies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const room_occupancy_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/rooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rooms_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /(:locale)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/:authenticator_id/saml(.:format)
 * @param {any} authenticator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_path = /*#__PURE__*/ __jsr.r({"authenticator_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_create_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_destroy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_group_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_replace_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/ServiceProviderConfig(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_service_provider_config_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"ServiceProviderConfig"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_show_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/scim/Users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/search_applicable_products(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_applicable_products_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_applicable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/search_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_components_onboarding_products_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search_components"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/search_cruise_lines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_cruise_lines_onboarding_products_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search_cruise_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/search_importable_products(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_importable_products_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_importable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/search_operator_applicable_products(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_operator_applicable_products_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_operator_applicable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/search_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_results_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"search_results"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sections_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/send_guest_cancellation_letter(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_guest_cancellation_letter_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_guest_cancellation_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tickets/session_tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_tickets_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"session_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/activity_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_activity_type_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"activity_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/activity_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_activity_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"activity_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_documents_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/general_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_general_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_internal_tags_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags/add_internal_tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_internal_tags_add_internal_tag_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"add_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags/remove_internal_tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_internal_tags_remove_internal_tag_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"remove_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/internal_tags/update_internal_tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_internal_tags_update_internal_tag_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"update_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/inventory/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_inventory_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/inventory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_inventory_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/operator_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_operator_applications_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operator_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/tour_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_tour_type_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/tour_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_tour_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/vehicle_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_vehicle_type_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"vehicle_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/vehicle_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_vehicle_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"vehicle_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/settlement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/special_requirement_bookings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const special_requirement_bookings_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"special_requirement_bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/conversations/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_conversations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/operator_check_in/submit_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_events_operator_check_in_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_check_in"],[2,[7,"/"],[2,[6,"submit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/manual_booking/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_manual_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/daily_settlement/submit_received_tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_received_tickets_daily_settlement_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_settlement"],[2,[7,"/"],[2,[6,"submit_received_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reviews/:id/submit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_review_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/operator_check_in/submit_ticket_scan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_ticket_scan_operator_check_in_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_check_in"],[2,[7,"/"],[2,[6,"submit_ticket_scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/contracting/cruise_line/summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_onboarding_contracting_cruise_line_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cruise_line"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_products/:tour_product_id/tickets/test(.:format)
 * @param {any} tour_product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_tour_product_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_product_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[3,"tour_product_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:tour_id/tickets/test(.:format)
 * @param {any} tour_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_tour_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tickets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticket_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tickets/:id/ticket_overrides(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticket_overrides_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ticket_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/timeslots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeslot_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/timeslots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeslots_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/top_bar/background_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_bar_background_tasks_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"top_bar"],[2,[7,"/"],[2,[6,"background_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_booking_passengers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_booking_passenger_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_booking_passengers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_booking_passengers_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:tour_booking_id/tickets(.:format)
 * @param {any} tour_booking_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_booking_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_booking_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"tour_booking_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/tour_change_letters(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_change_letters_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tour_change_letters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:tour_id/guest_complaints/:id(.:format)
 * @param {any} tour_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_guest_complaint_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:tour_id/guest_complaints(.:format)
 * @param {any} tour_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_guest_complaints_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_products_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/tour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/ticket_overrides(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_ticket_overrides_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ticket_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:tour_id/tickets(.:format)
 * @param {any} tour_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tour_tickets_path = /*#__PURE__*/ __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tours_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transport_rental_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transport_rentals_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_classes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transport_rentals_vehicle_class_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_classes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transport_rentals_vehicle_classes_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_pools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transport_rentals_vehicle_pool_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/transport_rentals/vehicle_pools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transport_rentals_vehicle_pools_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/tour_library/products/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchive_onboarding_tour_library_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/unassign_from_company(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unassign_from_company_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign_from_company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/prospective_award_sets/:id/unassign_operator(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unassign_operator_onboarding_prospective_award_set_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"prospective_award_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ui_error_test/uncaught_expection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncaught_expection_ui_error_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"uncaught_expection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/unlock_days(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlock_days_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"unlock_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/update_allotment_constraints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_allotment_constraints_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"update_allotment_constraints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/update_component(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_component_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_component"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/inventory_allocation/update_departures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_departures_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"update_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/update_field_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_field_settings_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_field_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/update_fields(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_fields_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/update_internal_tag(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_internal_tag_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/update_inventory(.:format)
 * @param {any} season_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_inventory_onboarding_inventory_allocation_path = /*#__PURE__*/ __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"update_inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/products/:id/update_main_details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_main_details_onboarding_product_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_main_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tours/:id/update_stickers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_stickers_tour_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_stickers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:user_id/authenticator(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_authenticator_path = /*#__PURE__*/ __jsr.r({"locale":{},"user_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"authenticator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding/exports/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_onboarding_exports_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/voyage_chooser(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voyage_chooser_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyage_chooser"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/manual_booking/voyage_timeline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voyage_timeline_manual_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[2,[7,"/"],[2,[6,"voyage_timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/voyages/itineraries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voyages_itineraries_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyages"],[2,[7,"/"],[2,[6,"itineraries"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/voyages/ships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voyages_ships_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyages"],[2,[7,"/"],[2,[6,"ships"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/private_car_bookings/:id/waitlist(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waitlist_private_car_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tour_bookings/:id/waitlist(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waitlist_tour_booking_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);



export default /**
 * File generated by js-routes 2.2.7
 * Based on Rails 7.1.4.2 routes of Shoretime::Application
 */
// eslint-disable-next-line
(
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{
  /**
   * Generates rails route to
   * (/:locale)/tours/:id/accept_arrangements(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  accept_arrangements_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept_arrangements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/accept_bid(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  accept_bid_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_applications/:id/accept(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  accept_onboarding_operator_application_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/exports/active_operator_application_signatories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  active_operator_application_signatories_onboarding_exports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"active_operator_application_signatories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/add_contract_period(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_contract_period_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_contract_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/add_departure(.:format)
   * @param {any} season_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_departure_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"add_departure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/add_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_departures_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"add_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/agent_health_check(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  agent_health_check_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"agent_health_check"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/allocate_inventory(.:format)
   * @param {any} season_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  allocate_inventory_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"allocate_inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dashboard/alternative_tours(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  alternative_tours_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"alternative_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/append_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  append_departures_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"append_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles/apply_to_cruise_company(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  apply_to_cruise_company_onboarding_operator_profiles_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[6,"apply_to_cruise_company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/apply_to_tours_diff(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  apply_to_tours_diff_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_to_tours_diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/apply_to_tours(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  apply_to_tours_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_to_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/apply_to_tours_run(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  apply_to_tours_run_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_to_tours_run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/approve_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  approve_departures_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"approve_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/approve_or_reject(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  approve_or_reject_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_or_reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/approve(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  approve_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/products/:id/archive(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  archive_onboarding_tour_library_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/assign_bidding_regions(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_bidding_regions_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_bidding_regions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/prospective_award_sets/:id/assign_operator(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_operator_onboarding_prospective_award_set_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"prospective_award_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/assign_roles(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_roles_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  authenticator_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/:authenticator_id/disable_scim(.:format)
   * @param {any} authenticator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  authenticator_disable_scim_path: __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"disable_scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/:authenticator_id/enable(.:format)
   * @param {any} authenticator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  authenticator_enable_path: __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/:authenticator_id/enable_scim(.:format)
   * @param {any} authenticator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  authenticator_enable_scim_path: __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"enable_scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/:authenticator_id/reset_scim(.:format)
   * @param {any} authenticator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  authenticator_reset_scim_path: __jsr.r({"locale":{},"authenticator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"reset_scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  authenticators_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/auto_instrument_expection(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  auto_instrument_expection_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"auto_instrument_expection"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/prospective_award_sets/:id/award_bids(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  award_bids_onboarding_prospective_award_set_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"prospective_award_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"award_bids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/basic(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  basic_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"basic"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tickets/batch_print(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_print_tickets_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"batch_print"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/tour_change_letters/batch_print(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_print_tour_change_letters_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tour_change_letters"],[2,[7,"/"],[2,[6,"batch_print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/bid(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bid_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/booking_guests(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  booking_guests_guest_complaints_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"booking_guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/bookings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bookings_guest_complaints_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/bulk_cancel(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bulk_cancel_tour_bookings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[6,"bulk_cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/bulk_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bulk_export_onboarding_tour_library_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"bulk_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_applications/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_onboarding_operator_application_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dashboard/cancel_port(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_port_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"cancel_port"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_private_car_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/caught_expection_string(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  caught_expection_string_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"caught_expection_string"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/caught_expection(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  caught_expection_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"caught_expection"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/company_chooser/choose/:company_id(.:format)
   * @param {any} company_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  choose_company_chooser_path: __jsr.r({"locale":{},"company_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_chooser"],[2,[7,"/"],[2,[6,"choose"],[2,[7,"/"],[2,[3,"company_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/crew_chooser/choose/:crew_id(.:format)
   * @param {any} crew_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  choose_crew_chooser_path: __jsr.r({"locale":{},"crew_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"crew_chooser"],[2,[7,"/"],[2,[6,"choose"],[2,[7,"/"],[2,[3,"crew_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/voyage_chooser/choose/:voyage_id(.:format)
   * @param {any} voyage_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  choose_voyage_chooser_path: __jsr.r({"locale":{},"voyage_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyage_chooser"],[2,[7,"/"],[2,[6,"choose"],[2,[7,"/"],[2,[3,"voyage_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/cleared_to_leave(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cleared_to_leave_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cleared_to_leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_sales/:id/close(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  close_daily_sale_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/close_days(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  close_days_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"close_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/close(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  close_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/comment(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  comment_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/company_chooser(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_chooser_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_chooser"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/company/:company_uri/login(.:format)
   * @param {any} company_uri
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_login_path: __jsr.r({"locale":{},"company_uri":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[3,"company_uri"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/complaint_categories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  complaint_categories_guest_complaints_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"complaint_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/components/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  component_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/components(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  components_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/confirm_email_addresses/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_email_address_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"confirm_email_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/confirm_email(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_email_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"confirm_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/settlement/confirm_guests(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_guests_settlement_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"confirm_guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/:id/confirm(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_private_car_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/confirm(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dashboard/confirmable_bookings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirmable_bookings_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"confirmable_bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/conversations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  conversation_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/conversations/:id/messages(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  conversation_messages_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/conversations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  conversations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/crew_chooser(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  crew_chooser_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"crew_chooser"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_manifest(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  daily_manifest_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_manifest"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_sales/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  daily_sale_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_sales(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  daily_sales_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_settlement(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  daily_settlement_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_settlement"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/background_jobs/exports/:id/download(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_background_jobs_export_download_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/background_jobs/exports/:id/report(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_background_jobs_export_report_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/background_jobs/exports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_background_jobs_exports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/background_jobs/imports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_background_jobs_imports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"background_jobs"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_export_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/export_items(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_export_items_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"export_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/analytics_feed/branded_tour_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_analytics_feed_branded_tour_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"branded_tour_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/analytics_feed/inventory_departure_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_analytics_feed_inventory_departure_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"inventory_departure_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/analytics_feed/operator_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_analytics_feed_operator_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"operator_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/analytics_feed/operator_insurance_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_analytics_feed_operator_insurance_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"operator_insurance_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/analytics_feed/sales_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_analytics_feed_sales_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"sales_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/analytics_feed/voyage_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_analytics_feed_voyage_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"analytics_feed"],[2,[7,"/"],[2,[6,"voyage_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/internal_tour_status(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_internal_tour_status_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"internal_tour_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/allocation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_inventory_allocation_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"allocation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/departure_allocations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_inventory_departure_allocations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_allocations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/departure_changes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_inventory_departure_changes_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/sales(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_inventory_sales_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/tracker(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_inventory_tracker_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"tracker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/nclh/branded_tour_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_nclh_branded_tour_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"branded_tour_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/nclh/inventory_departure_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_nclh_inventory_departure_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"inventory_departure_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/nclh/operator_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_nclh_operator_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"operator_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/nclh/operator_insurance_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_nclh_operator_insurance_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"operator_insurance_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/nclh/sales_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_nclh_sales_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"sales_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/nclh/voyage_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_nclh_voyage_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"nclh"],[2,[7,"/"],[2,[6,"voyage_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/otalio_export_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_otalio_export_settings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_export_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/otalio_product_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_otalio_product_export_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_product_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/tour_cost(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_exports_tour_cost_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"tour_cost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_import_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/import_items(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_import_items_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"import_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_imports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/:import_type/sample(.:format)
   * @param {any} import_type
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_imports_import_sample_path: __jsr.r({"locale":{},"import_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"import_type"],[2,[7,"/"],[2,[6,"sample"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/ims_voyage_import(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_imports_ims_voyage_import_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"ims_voyage_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/otalio_sales_import(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_imports_otalio_sales_import_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"otalio_sales_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/integrations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  data_exchange_integrations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/departed(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  departed_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"departed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/disable(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  disable_authenticators_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/disable(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  disable_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dispatch(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dispatch_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/dispatch_started(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dispatch_started_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dispatch_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/settlement/dispute(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dispute_settlement_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"dispute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/:id/download_bid(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_bid_onboarding_tour_library_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/authenticator/download_certificate/:certificate_name/:token(.:format)
   * @param {any} certificate_name
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_certificate_users_path: __jsr.r({"locale":{},"certificate_name":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"authenticator"],[2,[7,"/"],[2,[6,"download_certificate"],[2,[7,"/"],[2,[3,"certificate_name"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/:id/download(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_onboarding_tour_library_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/components/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_component_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_sales/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_daily_sale_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_data_exchange_export_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/edit_departure_time(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_departure_time_tour_bookings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[6,"edit_departure_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guest_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guest_complaint_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_booked_tour_account/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guests_booked_tour_account_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_feedback/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guests_feedback_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_room_accounts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guests_room_account_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tours/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guests_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tour_description/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_guests_tour_description_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passengers/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_passenger_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passenger_prices/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_passenger_price_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/ports/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_port_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_private_car_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reset_password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_reset_password_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reset_password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/rooms/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_room_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/room_occupancies/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_room_occupancy_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/general_settings/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_settings_general_settings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/tour_types/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_settings_tour_type_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/timeslots/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_timeslot_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_booking_passengers/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tour_booking_passenger_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:tour_id/guest_complaints/:id/edit(.:format)
   * @param {any} tour_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tour_guest_complaint_path: __jsr.r({"locale":{},"tour_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_products/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tour_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_transport_rental_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_classes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_transport_rentals_vehicle_class_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_pools/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_transport_rentals_vehicle_pool_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/email(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  email_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tickets/:id/embed(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  embed_ticket_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/enable(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  enable_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/export_bids(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_bids_onboarding_bidding_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"export_bids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dashboard/export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/departure_allocations/export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_data_exchange_exports_inventory_departure_allocations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_allocations"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/inventory/departure_changes/export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_data_exchange_exports_inventory_departure_changes_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"departure_changes"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/tour_cost/export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_data_exchange_exports_tour_cost_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"tour_cost"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_onboarding_tour_library_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /feature_flags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  feature_flags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/field_import_diff(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  field_import_diff_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"field_import_diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /file_holders/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  file_holder_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_holders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/insurance_dashboard/filter(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filter_insurance_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"insurance_dashboard"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/filter(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filter_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/filter(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filter_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/settlement/finalize(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  finalize_settlement_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guest_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guest_complaint_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guest_complaints_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_booked_tour_account/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_booked_tour_account_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_booked_tour_account/:guests_booked_tour_account_id/guests_booked_tour_account(.:format)
   * @param {any} guests_booked_tour_account_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_booked_tour_account_guests_booked_tour_account_path: __jsr.r({"locale":{},"guests_booked_tour_account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[3,"guests_booked_tour_account_id"],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_booked_tour_account(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_booked_tour_account_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_feedback/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_feedback_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_feedback/:guests_feedback_id/guests_feedback(.:format)
   * @param {any} guests_feedback_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_feedback_guests_feedback_path: __jsr.r({"locale":{},"guests_feedback_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[3,"guests_feedback_id"],[2,[7,"/"],[2,[6,"guests_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_feedback(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_feedback_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_room_accounts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_room_account_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_room_accounts/:guests_room_account_id/guests_room_accounts(.:format)
   * @param {any} guests_room_account_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_room_account_guests_room_accounts_path: __jsr.r({"locale":{},"guests_room_account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[3,"guests_room_account_id"],[2,[7,"/"],[2,[6,"guests_room_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_room_accounts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_room_accounts_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tours/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tour_description/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_tour_description_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tour_description/:guests_tour_description_id/guests_tour_description(.:format)
   * @param {any} guests_tour_description_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_tour_description_guests_tour_description_path: __jsr.r({"locale":{},"guests_tour_description_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[3,"guests_tour_description_id"],[2,[7,"/"],[2,[6,"guests_tour_description"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tour_description(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_tour_description_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tours/:guests_tour_id/guests_tours(.:format)
   * @param {any} guests_tour_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_tour_guests_tours_path: __jsr.r({"locale":{},"guests_tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[3,"guests_tour_id"],[2,[7,"/"],[2,[6,"guests_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tours(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guests_tours_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/identity_provider(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  identity_provider_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"identity_provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/guest_complaints/input(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  input_reports_guest_complaints_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/revenue/input(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  input_reports_revenue_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/revenue_sources/input(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  input_reports_revenue_sources_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue_sources"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/voyage_revenues/input(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  input_reports_voyage_revenues_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voyage_revenues"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/insurance_dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  insurance_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"insurance_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/inventory/inventory(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  inventory_settings_inventory_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles/invite_operator(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  invite_operator_onboarding_operator_profiles_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[6,"invite_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/lock_days(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lock_days_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"lock_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  logout_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/lookup(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lookup_users_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/manual_booking(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manual_booking_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_settlement/mark_as_paid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mark_as_paid_daily_settlement_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_settlement"],[2,[7,"/"],[2,[6,"mark_as_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/conversations/:id/mark_as_read(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mark_as_read_conversation_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_path: __jsr.r({}, [2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_root_path: __jsr.r({}, [2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/mass_update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_mass_update_jobs_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/:id/discard(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_discard_job_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/:id/force_discard(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_force_discard_job_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/:id/reschedule(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_reschedule_job_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/:id/retry(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_retry_job_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_jobs_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_job_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/metrics/primary_nav(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_metrics_primary_nav_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"primary_nav"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/jobs/metrics/job_status(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_metrics_job_status_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"job_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/batches(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_batches_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/batches/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_batch_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/cron_entries/:cron_key/enqueue(.:format)
   * @param {any} cron_key
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_enqueue_cron_entry_path: __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enqueue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/cron_entries/:cron_key/enable(.:format)
   * @param {any} cron_key
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_enable_cron_entry_path: __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/cron_entries/:cron_key/disable(.:format)
   * @param {any} cron_key
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_disable_cron_entry_path: __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/cron_entries(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_cron_entries_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/cron_entries/:cron_key(.:format)
   * @param {any} cron_key
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_cron_entry_path: __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/processes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_processes_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/performance(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_performance_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"performance"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/frontend/modules/:name(.:format)
   * @param {any} name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_frontend_module_path: __jsr.r({"name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mc/jobs/frontend/static/:name(.:format)
   * @param {any} name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mc_good_job_frontend_static_path: __jsr.r({"name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"mc"],[2,[7,"/"],[6,"jobs"]]]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"static"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/components/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_component_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_sales/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_daily_sale_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_export_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/otalio_export_settings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_exports_otalio_export_setting_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_export_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/otalio_product_export/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_exports_otalio_product_export_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"otalio_product_export"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_import_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/ims_voyage_import/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_imports_ims_voyage_import_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"ims_voyage_import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/otalio_sales_import/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_imports_otalio_sales_import_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"otalio_sales_import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/integrations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_data_exchange_integration_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guest_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guest_complaint_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_booked_tour_account/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guests_booked_tour_account_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_booked_tour_account"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_feedback/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guests_feedback_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_feedback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_room_accounts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guests_room_account_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_room_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tours/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guests_tour_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guests_tour_description/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_guests_tour_description_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guests_tour_description"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/off_schedule_inventories/remove_departures/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_off_schedule_inventories_remove_departure_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"off_schedule_inventories"],[2,[7,"/"],[2,[6,"remove_departures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/accept_contract_period_details_rejection/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_accept_contract_period_details_rejection_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_contract_period_details_rejection"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/accept_tender_bid/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_accept_tender_bid_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/appoint_operator/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_appoint_operator_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"appoint_operator"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/close_current_tender_bidding_round/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_close_current_tender_bidding_round_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"close_current_tender_bidding_round"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/confirm_contract_period_details/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_confirm_contract_period_detail_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"confirm_contract_period_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/contract_tours/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_contract_tour_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"contract_tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/cruise_line_suggest_contract_period_details_confirmation/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_cruise_line_suggest_contract_period_details_confirmation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"cruise_line_suggest_contract_period_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/deny_appointment/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_deny_appointment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"deny_appointment"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/enable_product_component_bidding/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_enable_product_component_bidding_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"enable_product_component_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/invite_tender_bidders/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_invite_tender_bidder_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_tender_bidders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/invite_to_bid/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_invite_to_bid_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_to_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/lock_product_component_editing/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_lock_product_component_editing_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"lock_product_component_editing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/open_current_tender_bidding_round/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_open_current_tender_bidding_round_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"open_current_tender_bidding_round"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/pend_tender_bid/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_pend_tender_bid_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"pend_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/reject_contract_period_details/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_reject_contract_period_detail_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/reject_contract_period_details_rejection/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_reject_contract_period_details_rejection_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details_rejection"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/reject_tender_bid/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_reject_tender_bid_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/request_bid_resubmission/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_request_bid_resubmission_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_bid_resubmission"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/request_contract_period_details_confirmation/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_request_contract_period_details_confirmation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_contract_period_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/request_tour_details_confirmation/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_request_tour_details_confirmation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_tour_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/revoke_bid_invitations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_revoke_bid_invitation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_bid_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/revoke_tender_bid_invite/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_revoke_tender_bid_invite_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_tender_bid_invite"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/submit_cost_changes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_submit_cost_change_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_cost_changes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/submit_tender_bid/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_submit_tender_bid_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_tender_bid"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/suggest_contract_period_details_confirmation/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_suggest_contract_period_details_confirmation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"suggest_contract_period_details_confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/unlock_product_component_editing/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_unlock_product_component_editing_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"unlock_product_component_editing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_bidding_deadline/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_update_bidding_deadline_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_bidding_deadline"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_field_permissions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_update_field_permission_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_field_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_individual_field_permissions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_update_individual_field_permission_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_individual_field_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_participation_counts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_update_participation_count_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_participation_counts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_pricing/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_update_pricing_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_pricing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_ratesheet_type_lock/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_bidding_update_ratesheet_type_lock_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_ratesheet_type_lock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/accept_product_appointments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_contracting_accept_product_appointment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"accept_product_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/cancel_product_appointments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_contracting_cancel_product_appointment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cancel_product_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/finalize_product_appointments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_contracting_finalize_product_appointment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"finalize_product_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/operator_percentage_assignment/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_contracting_operator_percentage_assignment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"operator_percentage_assignment"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/reopen_products_for_bidding/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_contracting_reopen_products_for_bidding_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"reopen_products_for_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/revert_contracting/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_contracting_revert_contracting_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"revert_contracting"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/edit_main_details/new(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_edit_main_detail_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_main_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_registrations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_operator_registration_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_registrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_operators/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_add_operator_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_operators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_ports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_add_port_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_ports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_season/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_add_season_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/archive_season/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_archive_season_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"archive_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/duplicate_season_for_bidding/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_duplicate_season_for_bidding_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_for_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/duplicate_season_with_appointments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_duplicate_season_with_appointment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_with_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/remove_operators/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_remove_operator_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_operators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/remove_ports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_remove_port_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_ports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/renew_tour_appointments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_renew_tour_appointment_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tour_appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/renew_tours_for_bidding/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_renew_tours_for_bidding_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tours_for_bidding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/unarchive_season/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_unarchive_season_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"unarchive_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/update_season/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_seasons_update_season_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"update_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/cruise_lines/add_tour/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_library_cruise_lines_add_tour_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/cruise_lines/add_tour_to_season/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_library_cruise_lines_add_tour_to_season_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour_to_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/cruise_lines/update_status_tag/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_library_cruise_lines_update_status_tag_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"update_status_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/operators/add_tour_idea/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_library_operators_add_tour_idea_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"operators"],[2,[7,"/"],[2,[6,"add_tour_idea"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_season/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_marketplace_add_tour_ideas_to_season_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_tour_library/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_marketplace_add_tour_ideas_to_tour_library_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_tour_library"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace/product_proposal_management/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_onboarding_tour_marketplace_product_proposal_management_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"product_proposal_management"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passengers/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_passenger_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passenger_prices/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_passenger_price_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /platforms/super_admins/iams/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_platforms_super_admins_iam_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"platforms"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"iams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/ports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_port_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_private_car_booking_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reset_password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_reset_password_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reset_password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/rooms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_room_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/room_occupancies/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_room_occupancy_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/general_settings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_settings_general_settings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags/add_internal_tag/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_settings_internal_tags_add_internal_tag_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"add_internal_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags/remove_internal_tag/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_settings_internal_tags_remove_internal_tag_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"remove_internal_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags/update_internal_tag/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_settings_internal_tags_update_internal_tag_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"update_internal_tag"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/tour_types/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_settings_tour_type_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/timeslots/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_timeslot_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tour_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tour_booking_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_booking_passengers/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tour_booking_passenger_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:tour_id/guest_complaints/new(.:format)
   * @param {any} tour_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tour_guest_complaint_path: __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_products/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tour_product_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_transport_rental_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_classes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_transport_rentals_vehicle_class_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_pools/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_transport_rentals_vehicle_pool_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/off_schedule_inventories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  off_schedule_inventories_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"off_schedule_inventories"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/off_schedule_inventories/remove_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  off_schedule_inventories_remove_departures_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"off_schedule_inventories"],[2,[7,"/"],[2,[6,"remove_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/authenticators/offload(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  offload_authenticators_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authenticators"],[2,[7,"/"],[2,[6,"offload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_admin_status_dashboard/:operator_id/archive(.:format)
   * @param {any} operator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_archive_operator_admin_status_dashboard_path: __jsr.r({"locale":{},"operator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_admin_status_dashboard"],[2,[7,"/"],[2,[3,"operator_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/accept_contract_period_details_rejection(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_accept_contract_period_details_rejection_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_contract_period_details_rejection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/accept_tender_bid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_accept_tender_bid_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"accept_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/appoint_operator(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_appoint_operator_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"appoint_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/close_current_tender_bidding_round(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_close_current_tender_bidding_round_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"close_current_tender_bidding_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/confirm_contract_period_details(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_confirm_contract_period_details_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"confirm_contract_period_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/contract_tours(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_contract_tours_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"contract_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/cruise_line_suggest_contract_period_details_confirmation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_cruise_line_suggest_contract_period_details_confirmation_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"cruise_line_suggest_contract_period_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/deny_appointment(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_deny_appointment_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"deny_appointment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/enable_product_component_bidding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_enable_product_component_bidding_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"enable_product_component_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/invite_tender_bidders(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_invite_tender_bidders_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_tender_bidders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/invite_to_bid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_invite_to_bid_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"invite_to_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/lock_product_component_editing(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_lock_product_component_editing_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"lock_product_component_editing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/open_current_tender_bidding_round(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_open_current_tender_bidding_round_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"open_current_tender_bidding_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding_overview(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_overview_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding_overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/pend_tender_bid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_pend_tender_bid_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"pend_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/reject_contract_period_details(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_reject_contract_period_details_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/reject_contract_period_details_rejection(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_reject_contract_period_details_rejection_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_contract_period_details_rejection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/reject_tender_bid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_reject_tender_bid_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"reject_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/request_bid_resubmission(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_request_bid_resubmission_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_bid_resubmission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/request_contract_period_details_confirmation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_request_contract_period_details_confirmation_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_contract_period_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/request_tour_details_confirmation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_request_tour_details_confirmation_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"request_tour_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/revoke_bid_invitations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_revoke_bid_invitations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_bid_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/revoke_tender_bid_invite(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_revoke_tender_bid_invite_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"revoke_tender_bid_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/submit_cost_changes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_submit_cost_changes_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_cost_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/submit_tender_bid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_submit_tender_bid_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"submit_tender_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/suggest_contract_period_details_confirmation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_suggest_contract_period_details_confirmation_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"suggest_contract_period_details_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/unlock_product_component_editing(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_unlock_product_component_editing_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"unlock_product_component_editing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_bidding_deadline(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_bidding_deadline_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_bidding_deadline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_field_permissions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_field_permissions_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_field_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_individual_field_permissions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_individual_field_permissions_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_individual_field_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_participation_counts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_participation_counts_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_participation_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_pricing(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_pricing_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_pricing(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_pricing_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_ratesheet_type_lock(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_ratesheet_type_lock_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_ratesheet_type_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/bidding/update_ratesheet_type_lock(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_bidding_update_ratesheet_type_lock_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"bidding"],[2,[7,"/"],[2,[6,"update_ratesheet_type_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/accept_product_appointments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_accept_product_appointments_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"accept_product_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/cancel_product_appointments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_cancel_product_appointments_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cancel_product_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/cruise_line(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_cruise_line_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cruise_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/finalize_product_appointments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_finalize_product_appointments_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"finalize_product_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/operator(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_operator_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/operator_percentage_assignment(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_operator_percentage_assignment_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"operator_percentage_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/reopen_products_for_bidding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_reopen_products_for_bidding_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"reopen_products_for_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/revert_contracting(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_contracting_revert_contracting_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"revert_contracting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_documents_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/edit_main_details(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_edit_main_details_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_main_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/mismatched_sales_inventories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_mismatched_sales_inventories_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"mismatched_sales_inventories"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_admin_status_dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_admin_status_dashboard_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_admin_status_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_applications/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_application_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_profile_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles/:operator_profile_id/applications/:id/approve(.:format)
   * @param {any} operator_profile_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_profile_approve_application_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles/:operator_profile_id/applications/:id/reject(.:format)
   * @param {any} operator_profile_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_profile_reject_application_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles/:operator_profile_id/update_settings(.:format)
   * @param {any} operator_profile_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_profile_update_settings_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_profiles_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_profiles_dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_profiles_dashboard_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_profiles_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_registrations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_operator_registrations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/audit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_product_audit_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/cost_analysis(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_product_cost_analysis_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cost_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_products_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/:season_id/cost_analysis(.:format)
   * @param {any} season_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_season_cost_analysis_path: __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"cost_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_operators(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_add_operators_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_ports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_add_ports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_season(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_add_season_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/add_tours(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_add_tours_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"add_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/archive_season(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_archive_season_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"archive_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/duplicate_season_for_bidding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_duplicate_season_for_bidding_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_for_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/duplicate_season_with_appointments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_duplicate_season_with_appointments_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"duplicate_season_with_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/operators(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_operators_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/ports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_ports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/remove_operators(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_remove_operators_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/remove_ports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_remove_ports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"remove_ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/renew_tour_appointments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_renew_tour_appointments_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tour_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/renew_tours_for_bidding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_renew_tours_for_bidding_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"renew_tours_for_bidding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/tours(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_tours_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/unarchive_season(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_unarchive_season_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"unarchive_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/update_season(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_seasons_update_season_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[6,"update_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/cruise_lines/add_tour(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_library_cruise_lines_add_tour_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/cruise_lines/add_tour_to_season(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_library_cruise_lines_add_tour_to_season_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"add_tour_to_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/cruise_lines/update_status_tag(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_library_cruise_lines_update_status_tag_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"cruise_lines"],[2,[7,"/"],[2,[6,"update_status_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_library_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/operators/add_tour_idea(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_library_operators_add_tour_idea_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"operators"],[2,[7,"/"],[2,[6,"add_tour_idea"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_season(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_marketplace_add_tour_ideas_to_season_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace/add_tour_ideas_to_tour_library(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_marketplace_add_tour_ideas_to_tour_library_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"add_tour_ideas_to_tour_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_marketplace_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_marketplace/product_proposal_management(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_tour_marketplace_product_proposal_management_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_marketplace"],[2,[7,"/"],[2,[6,"product_proposal_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_admin_status_dashboard/:operator_id/unarchive(.:format)
   * @param {any} operator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_unarchive_operator_admin_status_dashboard_path: __jsr.r({"locale":{},"operator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_admin_status_dashboard"],[2,[7,"/"],[2,[3,"operator_id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_sales/:id/open(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  open_daily_sale_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/open_days(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  open_days_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"open_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/open(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  open_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/operator_check_in(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_check_in_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_check_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/operator_profiles/:operator_profile_id/insurances/:insurance_id/update_certificate(.:format)
   * @param {any} operator_profile_id
   * @param {any} insurance_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_profile_insurance_update_certificate_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"insurance_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[2,[7,"/"],[2,[3,"insurance_id"],[2,[7,"/"],[2,[6,"update_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/operator_profiles/:operator_profile_id/insurances/:insurance_id/update_selected_items(.:format)
   * @param {any} operator_profile_id
   * @param {any} insurance_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_profile_insurance_update_selected_items_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"insurance_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[2,[7,"/"],[2,[3,"insurance_id"],[2,[7,"/"],[2,[6,"update_selected_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/operator_profiles/:operator_profile_id/insurances/:insurance_id/upload_certificate(.:format)
   * @param {any} operator_profile_id
   * @param {any} insurance_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_profile_insurance_upload_certificate_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"insurance_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[2,[7,"/"],[2,[3,"insurance_id"],[2,[7,"/"],[2,[6,"upload_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/operator_profiles/:operator_profile_id/insurances(.:format)
   * @param {any} operator_profile_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_profile_insurances_path: __jsr.r({"locale":{},"operator_profile_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_profiles"],[2,[7,"/"],[2,[3,"operator_profile_id"],[2,[7,"/"],[2,[6,"insurances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_applications/:id/operator_questionnaire(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_questionnaire_onboarding_operator_application_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_questionnaire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/operator_registration(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operator_registration_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"operator_registration"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dispatch/operators(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  operators_dispatch_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[6,"operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passengers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  passenger_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passenger_prices/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  passenger_price_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passenger_prices(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  passenger_prices_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passenger_prices"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passengers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  passengers_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  password_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/pend_bid(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pend_bid_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pend_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /platforms/super_admins/iams(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  platforms_super_admins_iams_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"platforms"],[2,[7,"/"],[2,[6,"super_admins"],[2,[7,"/"],[2,[6,"iams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/ports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  port_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/manual_booking/port(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  port_manual_booking_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[2,[7,"/"],[2,[6,"port"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/ports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ports"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/exports/ports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ports_onboarding_exports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"ports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/settlement/price_breakdown(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  price_breakdown_settlement_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[2,[7,"/"],[2,[6,"price_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  private_car_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/:private_car_booking_id/tickets(.:format)
   * @param {any} private_car_booking_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  private_car_booking_tickets_path: __jsr.r({"locale":{},"private_car_booking_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"private_car_booking_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dispatch/private_villas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  private_villas_dispatch_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[6,"private_villas"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/exports/:id/process_export(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  process_export_data_exchange_export_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/data_exchange/imports/:id/process_import(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  process_import_data_exchange_import_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data_exchange"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/exports/product_comparison(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  product_comparison_onboarding_exports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"product_comparison"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/proposals/:proposal_id/accept(.:format)
   * @param {any} id
   * @param {any} proposal_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  proposal_accept_path: __jsr.r({"locale":{},"id":{"r":true},"proposal_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"proposal_id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/proposals/:proposal_id/reject(.:format)
   * @param {any} id
   * @param {any} proposal_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  proposal_reject_path: __jsr.r({"locale":{},"id":{"r":true},"proposal_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"proposal_id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/propose(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  propose_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"propose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/react_with_error_boundary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  react_with_error_boundary_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"react_with_error_boundary"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/react_without_error_boundary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  react_without_error_boundary_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"react_without_error_boundary"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/rebook(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rebook_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/refund(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  refund_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/reject_bid(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reject_bid_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/reject(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reject_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/remove_bid(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_bid_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/remove_departure(.:format)
   * @param {any} season_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_departure_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"remove_departure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/remove_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_departures_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"remove_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/replace_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  replace_departures_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"replace_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/conversations/:id/reply(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reply_conversation_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/daily_spend(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_daily_spend_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"daily_spend"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/guest_complaints(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_guest_complaints_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guest_complaints"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/revenue(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_revenue_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/revenue_sources(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_revenue_sources_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/voyage_performance(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_voyage_performance_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voyage_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reports/voyage_revenues(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reports_voyage_revenues_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voyage_revenues"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/request_password_reset(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_password_reset_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/resend_email_confirmation(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resend_email_confirmation_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_email_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/reset(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reset_password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_password_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session/reset(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/guest_complaints/:id/resolve(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resolve_guest_complaint_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/operator_applications/:id/retract(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  retract_onboarding_operator_application_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"operator_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/return_to_setup(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  return_to_setup_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"return_to_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dispatch/reverse(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reverse_dispatch_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[6,"reverse"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reviews/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  review_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/rooms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  room_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/passengers/:id/room_account(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  room_account_passenger_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"passengers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"room_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/room_occupancies(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  room_occupancies_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/room_occupancies/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  room_occupancy_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"room_occupancies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/rooms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rooms_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"rooms"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * /(:locale)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  root_path: __jsr.r({"locale":{},"format":{}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /auth/:authenticator_id/saml(.:format)
   * @param {any} authenticator_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  saml_path: __jsr.r({"authenticator_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"authenticator_id"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_create_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_destroy_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Groups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_group_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_replace_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_root_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/ServiceProviderConfig(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_service_provider_config_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"ServiceProviderConfig"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_show_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /auth/scim/Users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  scim_update_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/search_applicable_products(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_applicable_products_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_applicable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/search_components(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_components_onboarding_products_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search_components"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/search_cruise_lines(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_cruise_lines_onboarding_products_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search_cruise_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/search_importable_products(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_importable_products_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_importable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/search_operator_applicable_products(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_operator_applicable_products_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_operator_applicable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/search_results(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_results_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"search_results"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/sections/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  section_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/sections(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sections_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/send_guest_cancellation_letter(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_guest_cancellation_letter_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_guest_cancellation_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tickets/session_tickets(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  session_tickets_tickets_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"session_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/activity_types/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_activity_type_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"activity_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/activity_types(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_activity_types_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"activity_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_documents_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/general_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_general_settings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_internal_tags_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags/add_internal_tag(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_internal_tags_add_internal_tag_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"add_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags/remove_internal_tag(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_internal_tags_remove_internal_tag_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"remove_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/internal_tags/update_internal_tag(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_internal_tags_update_internal_tag_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"internal_tags"],[2,[7,"/"],[2,[6,"update_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/inventory/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_inventory_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/inventory(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_inventory_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/operator_applications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_operator_applications_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operator_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/tour_types/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_tour_type_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/tour_types(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_tour_types_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/vehicle_types/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_vehicle_type_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"vehicle_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/vehicle_types(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settings_vehicle_types_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"vehicle_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/settlement(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  settlement_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settlement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/dashboard/special_requirement_bookings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_requirement_bookings_dashboard_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"special_requirement_bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /sso(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sso_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/conversations/start(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  start_conversations_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/operator_check_in/submit_events(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submit_events_operator_check_in_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_check_in"],[2,[7,"/"],[2,[6,"submit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/manual_booking/submit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submit_manual_booking_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/daily_settlement/submit_received_tickets(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submit_received_tickets_daily_settlement_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"daily_settlement"],[2,[7,"/"],[2,[6,"submit_received_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/reviews/:id/submit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submit_review_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/operator_check_in/submit_ticket_scan(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submit_ticket_scan_operator_check_in_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"operator_check_in"],[2,[7,"/"],[2,[6,"submit_ticket_scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/contracting/cruise_line/summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  summary_onboarding_contracting_cruise_line_index_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"contracting"],[2,[7,"/"],[2,[6,"cruise_line"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_products/:tour_product_id/tickets/test(.:format)
   * @param {any} tour_product_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  test_tour_product_tickets_path: __jsr.r({"locale":{},"tour_product_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[3,"tour_product_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:tour_id/tickets/test(.:format)
   * @param {any} tour_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  test_tour_tickets_path: __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tickets/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ticket_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tickets/:id/ticket_overrides(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ticket_overrides_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ticket_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tickets(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tickets_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/timeslots/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  timeslot_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/timeslots(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  timeslots_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/top_bar/background_tasks(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  top_bar_background_tasks_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"top_bar"],[2,[7,"/"],[2,[6,"background_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_booking_passengers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_booking_passenger_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_booking_passengers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_booking_passengers_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_booking_passengers"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:tour_booking_id/tickets(.:format)
   * @param {any} tour_booking_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_booking_tickets_path: __jsr.r({"locale":{},"tour_booking_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"tour_booking_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/tour_change_letters(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_change_letters_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tour_change_letters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:tour_id/guest_complaints/:id(.:format)
   * @param {any} tour_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_guest_complaint_path: __jsr.r({"locale":{},"tour_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:tour_id/guest_complaints(.:format)
   * @param {any} tour_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_guest_complaints_path: __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"guest_complaints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_products/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_products(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_products_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_products"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/settings/tour(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_settings_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"tour"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/ticket_overrides(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_ticket_overrides_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ticket_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:tour_id/tickets(.:format)
   * @param {any} tour_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tour_tickets_path: __jsr.r({"locale":{},"tour_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"tour_id"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tours_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  transport_rental_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  transport_rentals_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_classes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  transport_rentals_vehicle_class_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_classes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  transport_rentals_vehicle_classes_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_classes"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_pools/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  transport_rentals_vehicle_pool_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/transport_rentals/vehicle_pools(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  transport_rentals_vehicle_pools_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"transport_rentals"],[2,[7,"/"],[2,[6,"vehicle_pools"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/tour_library/products/:id/unarchive(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unarchive_onboarding_tour_library_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"tour_library"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id/unassign_from_company(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unassign_from_company_user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign_from_company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/prospective_award_sets/:id/unassign_operator(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unassign_operator_onboarding_prospective_award_set_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"prospective_award_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign_operator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /ui_error_test/uncaught_expection(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  uncaught_expection_ui_error_test_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_error_test"],[2,[7,"/"],[2,[6,"uncaught_expection"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/unlock_days(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unlock_days_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"unlock_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/update_allotment_constraints(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_allotment_constraints_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"update_allotment_constraints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/update_component(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_component_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_component"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/inventory_allocation/update_departures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_departures_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"update_departures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/update_field_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_field_settings_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_field_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/update_fields(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_fields_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/update_internal_tag(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_internal_tag_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_internal_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/seasons/:season_id/inventory_allocation/update_inventory(.:format)
   * @param {any} season_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_inventory_onboarding_inventory_allocation_path: __jsr.r({"locale":{},"season_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"inventory_allocation"],[2,[7,"/"],[2,[6,"update_inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/products/:id/update_main_details(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_main_details_onboarding_product_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_main_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tours/:id/update_stickers(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_stickers_tour_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_stickers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users/:user_id/authenticator(.:format)
   * @param {any} user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_authenticator_path: __jsr.r({"locale":{},"user_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"authenticator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/user_session(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_session_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_session"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  users_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/onboarding/exports/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  users_onboarding_exports_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/voyage_chooser(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  voyage_chooser_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyage_chooser"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/manual_booking/voyage_timeline(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  voyage_timeline_manual_booking_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manual_booking"],[2,[7,"/"],[2,[6,"voyage_timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/voyages/itineraries(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  voyages_itineraries_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyages"],[2,[7,"/"],[2,[6,"itineraries"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/voyages/ships(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  voyages_ships_path: __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"voyages"],[2,[7,"/"],[2,[6,"ships"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/private_car_bookings/:id/waitlist(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  waitlist_private_car_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"private_car_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tour_bookings/:id/waitlist(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  waitlist_tour_booking_path: __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tour_bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]])}
,
    };
    Utils.define_module("NIL", result);
    return result;
})();

